<template>
  <div class="detail-outer-div">
    <div class="detail-title">{{title}}</div>
    <div class="detail-time"> {{time | datefull}}</div>
    <div class="detail-content"> {{description}}</div>
  </div>
</template>
<style lang="less" rel="stylesheet/less" scoped="">
  @import "../../utils/_vars";
  @header: 6.8rem;

  .detail-title {
    font-size: 2.4rem;
    font-weight: bold;
    font-family: 'PingFangSC-Regular', sans-serif;
    color: #222;
    margin-top: 3rem;
    margin-bottom: 1rem;
  }

  .detail-time {
    color: #888;
    font-size: 1.3rem;
    margin-bottom: 2rem;
  }

  .detail-content {
    font-size: 1.8rem;
    color: #313131;
    font-family: 'PingFangSC-Light', sans-serif;
  }

  .detail-outer-div {
    padding-left: 2.3rem;
    padding-right: 2rem;
  }
</style>
<script  >
  export default {
    name: 'uc',
    data() {
      return {
        title: '',
        time: '',
        description: '',
        detailsPath: '',
        createTime: '',
        htmlSrc: ''
      };
    },
    mounted: async function () {
      const { title, description, detailsPath, createTime } = this.$route.params;
      this.title = title;
      this.description = description;
      this.detailsPath = detailsPath;
      this.time = createTime;
      this.htmlSrc = detailsPath;
    },
    methods: {
      trackReport(name) {
        // 埋点
        this.$reportLog(name, 'btn', name);
      }
    },
    filters: {
      datefull(_val) {
        let val = Number(_val);
        if (!val) {
          return '';
        }
        const date = new Date(val);
        /* eslint-disable max-len */
        return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
        /* eslint-enable max-len */
      }
    }
  };
</script>
